import React from "react";
import { Card } from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import TabHeader from "@shared/country-components/tabHeader";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import { tabHeadingDictionary as tabKeywords } from "@core/global/global-country-dictionary";
import { Info } from "react-feather";
import UpgradeIcon from "@assets/images/Solid_Status_Lightning-alt.svg";
import { formatNumber } from "@utils/utils";
import { useSelector } from "react-redux";

const Shipment = (props) => {
  const userDetails = useSelector((state) => state.userDetails);
  return (
    <div>
      <div className={props.currentTab === tabKeywords.shipments ? "tab-pane fade show active" : "tab-pane fade"} id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div className="trademo-table-container">
          {!!props.currentPlanAccess && props.currentPlanAccess.shipments === false && props.currentTab === tabKeywords.shipments ? (
            <Card className="upgrade-card">
              <Card.Body>
                <div className="container">
                  <div className="row">
                    <div className="col-auto">
                      <div>
                        <img src={UpgradeIcon} alt="..." className="img-fluid" />
                      </div>
                    </div>
                    <div className="col">
                      <p>Access granular Bill of Lading for searched shipments</p>
                      <p>Upgrade to higher plan to use this feature</p>
                      <div className="d-block my-3">
                        <button type="button" className="btn btn-success tw-bg-secondary-green" onClick={props.upgradeNow}>
                          Upgrade
                        </button>
                      </div>
                      <div className="d-block">
                        <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1660819706/intel/Pro%20Lite%20Plan/shipments-illustration_ivzfsd.svg" alt="..." className="img-fluid" />
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ) : !!props.data && props.isLoaderActive === false ? (
            <div>
              {props.data.length >= 1 ? (
                <div className="tw-py-4 d-flex">
                  <div className="d-flex align-items-center">
                    {props.selectedSearchRowData.length > 0 ? (
                      <TabHeader
                        prospectData={props.selectedSearchRowData}
                        type="Shipments"
                        selectedData={props.selectedSearchRowData}
                        upgradePlansDictionary={props.upgradePlansDictionary}
                        userCredit={props.userCredit}
                        creditQuota={props.creditQuota}
                        totalDataCount={props.totalSearchCount}
                        defaultData={props.defaultData}
                        onClear={() => props.toggleClearButton("shipments")}
                        onDownload={(downloadFromValue, downloadToValue, selectAll, downloadShipmentPopupClose, isCustomGridDownload) => props.downloadShipmentFromPopup(downloadFromValue, downloadToValue, selectAll, downloadShipmentPopupClose, isCustomGridDownload)}
                        onSelect={(downloadShipmentPopupClose, isCustomGridDownload) => props.downloadSearch("XLS", "Shipments", downloadShipmentPopupClose, isCustomGridDownload)}
                        tradeDirection={props.defaultData.countryType}
                        dataSource={props.defaultData.country_small}
                        isTrademoAccount={props.isTrademoAccount && props.defaultData ? props.defaultData.isHandleTrademoAccount : null}
                        isSalesForceRedirection={props.isSalesForceRedirection}
                        addToFaV={props.addToFaV}
                        setAddToFav={(val) => props.setAddtoFav(val)}
                        currentUserPlan={props.currentUserPlan}
                        pathname={window.location.pathname}
                        analyticsCountryID={props.defaultData.analyticsCountryID}
                        isRedirect={props.isRedirect}
                        showBolFilter={props.showBolFilter}
                        redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                        redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className={props.selectedSearchRowData.length ? "d-flex pl-0 position-relative" : " d-flex pl-0 w-100 position-relative"}>
                    {/* <div className="trademo-side-filter ml-auto mx-2" /> */}
                    {props.selectedSearchRowData.length === 0 ? (
                      <TabHeader
                        prospectData={props.selectedSearchRowData}
                        type="Shipments"
                        selectedData={props.selectedSearchRowData}
                        upgradePlansDictionary={props.upgradePlansDictionary}
                        userCredit={props.userCredit}
                        creditQuota={props.creditQuota}
                        totalDataCount={props.totalSearchCount}
                        defaultData={props.defaultData}
                        onDownload={(downloadFromValue, downloadToValue, selectAll, downloadShipmentPopupClose, isCustomGridDownload) => props.downloadShipmentFromPopup(downloadFromValue, downloadToValue, selectAll, downloadShipmentPopupClose, isCustomGridDownload)}
                        onSelect={(downloadShipmentPopupClose, isCustomGridDownload) => props.downloadSearch("XLS", "Shipments", downloadShipmentPopupClose, isCustomGridDownload)}
                        tradeDirection={props.defaultData.countryType}
                        dataSource={props.defaultData.country_small}
                        isTrademoAccount={props.isTrademoAccount && props.defaultData ? props.defaultData.isHandleTrademoAccount : null}
                        isSalesForceRedirection={props.isSalesForceRedirection}
                        addToFaV={props.addToFaV}
                        userFirstPlan={props.userFirstPlan}
                        setAddToFav={(val) => props.setAddtoFav(val)}
                        currentUserPlan={props.currentUserPlan}
                        pathname={window.location.pathname}
                        analyticsCountryID={props.defaultData.analyticsCountryID}
                        isRedirect={props.isRedirect}
                        showBolFilter={props.showBolFilter}
                        redirectingCompanyExporterId={props.redirectingCompanyExporterId}
                        redirectingCompanyImporterId={props.redirectingCompanyImporterId}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div className={`${props?.data?.length > 0 && props?.searchTableColumns?.length === 0 ? "tw-w-full" : "d-block tw-border tw-rounded-lg"}`}>
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="detailview-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" multiline={true} id="hs-code-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="default-cell-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="grid-cell-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" effect="solid" id="shipment-value-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_1" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_2" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_3" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="id_4" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="shipment-company-array-tooltip" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" id="hs-code-inline-tooltip" />
                <ReactTableTrademo
                  columns={props.searchTableColumns}
                  data={props.data}
                  paginationTotalRows={props.totalSearchCount}
                  onSelectedRowsChange={(data) => props.selectedNewTableData(data)}
                  onSort={props.handleSortingClone}
                  defaultSortField={props.defaultData.sortKeyMap[props.sortValue] ? props.defaultData.sortKeyMap[props.sortValue] : "date"}
                  defaultSortAsc={props.sortOrderValue === "desc" ? false : true}
                  paginationPerPage={props.perPage}
                  onChangeRowsPerPage={props.handleTrademoTableSearchPerRowsChange}
                  onTableObjectChange={props.updateTrademoTableObject}
                  onChangePage={props.handleTrademoTablePageChange}
                  paginationDefaultPage={props.currentPage}
                  options={[25, 50, 100]}
                  noDataComponent={props.isLoaderActive === true || props.isDownloadLoaderActive === true || props.isTrendsActive ? "" : props.data && props.data.length === 0 && !props.isLoaderActive ? "No Shipments Found. Please try another search" : "Failed to fetch the Shipments Data"}
                  clearSelectedRows={!!props.shipmentToggleRows && props.shipmentToggleRows === true ? true : false}
                  selectedData={props.selectedSearchRowData}
                  shipmentDefaultSortValue={props.defaultData.shipmentSorting}
                  sortOrderValue={props.sortOrderValue}
                  isSalesForceRedirection={props.isSalesForceRedirection}
                  isRedirect={props.isRedirect}
                  currentUserPlan={props.currentUserPlan}
                  pathname={window.location.pathname}
                  analyticsCountryID={props.defaultData.analyticsCountryID}
                  type={props.type}
                />
                {window.location.href.includes("all-country-shipments") && Object.keys(props.filterData).length && props?.filterData?.dataSource?.length > 0 && userDetails?.userData && Object.keys(userDetails?.userData).length && userDetails?.userData?.email?.includes("trademo") ? (
                  <div className="">
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        props.setShowDataSource();
                      }}
                      className="dataSource-text">
                      <Info className="dataSource-info" />
                      <span className="ml-1">Datasource count</span>
                    </span>
                    {props.showDataSource ? (
                      <div className="position-absolute datasource-type-input">
                        <div>
                          {props.filterData.dataSource.filter((item) => item.key && item.key.includes("imports")).length ? (
                            <div className="dataSource_type">
                              <span>Imports</span>
                            </div>
                          ) : (
                            <></>
                          )}
                          {props.filterData.dataSource
                            .filter((item) => item.key && item.key.includes("imports"))
                            .map((country) => (
                              <div key={country.key} className="d-flex justify-content-between py-1">
                                <span className="datasource-type-countryName">{country.key}</span>
                                <span className="datasource-type-datacount">{formatNumber(country.doc_count)}</span>
                              </div>
                            ))}
                          {props.filterData.dataSource.filter((item) => item.key && item.key.includes("exports")).length ? (
                            <div className="dataSource_type">
                              <span>Exports</span>
                            </div>
                          ) : (
                            <></>
                          )}
                          {props.filterData.dataSource
                            .filter((item) => item.key && item.key.includes("exports"))
                            .map((country) => (
                              <div className="d-flex justify-content-between py-1" key={country.key}>
                                <span className="datasource-type-countryName">{country.key}</span>
                                <span className="datasource-type-datacount">{formatNumber(country.doc_count)}</span>
                              </div>
                            ))}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Shipment);
